(function() {
  'use strict';

  var overlay = document.querySelector('[data-search-overlay]');
  var input = document.querySelector('[data-search-input]');
  var results = document.querySelector('[data-search-results]');
  var toggleBtns = document.querySelectorAll('[data-search-toggle]');
  var debounceTimer;

  function open() {
    overlay.classList.add('open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { if (input) input.focus(); }, 100);
  }

  function close() {
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (input) input.value = '';
    if (results) results.innerHTML = '';
  }

  toggleBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (overlay.classList.contains('open')) {
        close();
      } else {
        open();
      }
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('open')) {
      close();
    }
  });

  if (input) {
    input.addEventListener('input', function() {
      var query = input.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < 2) {
        if (results) results.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function() {
        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page,article&resources[limit]=6')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            renderResults(data.resources.results);
          });
      }, 300);
    });
  }

  function renderResults(data) {
    if (!results) return;
    var html = '';

    if (data.products && data.products.length > 0) {
      html += '<div class="search-overlay__group">';
      html += '<h4 class="search-overlay__group-title">Produkte</h4>';
      data.products.forEach(function(product) {
        var img = product.image ? '<img src="' + product.image + '" alt="" width="48" height="48" loading="lazy">' : '';
        html += '<a href="' + product.url + '" class="search-overlay__item">';
        html += '<div class="search-overlay__item-img">' + img + '</div>';
        html += '<div class="search-overlay__item-info">';
        html += '<span class="search-overlay__item-title">' + product.title + '</span>';
        html += '<span class="search-overlay__item-price">' + product.price + '</span>';
        html += '</div></a>';
      });
      html += '</div>';
    }

    if (data.pages && data.pages.length > 0) {
      html += '<div class="search-overlay__group">';
      html += '<h4 class="search-overlay__group-title">Seiten</h4>';
      data.pages.forEach(function(page) {
        html += '<a href="' + page.url + '" class="search-overlay__item">';
        html += '<span class="search-overlay__item-title">' + page.title + '</span>';
        html += '</a>';
      });
      html += '</div>';
    }

    if (data.articles && data.articles.length > 0) {
      html += '<div class="search-overlay__group">';
      html += '<h4 class="search-overlay__group-title">Blog</h4>';
      data.articles.forEach(function(article) {
        html += '<a href="' + article.url + '" class="search-overlay__item">';
        html += '<span class="search-overlay__item-title">' + article.title + '</span>';
        html += '</a>';
      });
      html += '</div>';
    }

    if (!html) {
      html = '<p class="search-overlay__empty">Keine Ergebnisse gefunden.</p>';
    }

    results.innerHTML = html;
  }
})();
